export default {
    navigationBarTitleText: '完成进度详情'
  };
  